const BuildSystemInfo = {
  email: "admin@dominobuilder.com",
  systemApp: "https://dominobuilder.com",
  buildedBy: "Ninh Nguyen",
};

export default BuildSystemInfo;